export default {
  invoice_applu_tips_remark:
    "申请发票金额低于1000元时，我司只开具《普通电子发票》，不提供《增值税专用发票》",
  invoice_applu_tips_title:
    "请在下方列表中勾选您需要申请发票的订单商品，再选择发票类型",
  invoice_apply_time: "发票申请的开始时间为：",
  status_enumerate_canceled: "已取消",
  status_enumerate_passed: "已通过",
  status_enumerate_merged: "已合并",
  status_enumerate_cancel: "已导出",
  status_enumerate_refuse: "拒绝",
  status_enumerate_checked: "已审核",
  status_enumerate_checking: "审核中",
  status_enumerate_waitcheck: "待审核",
  mes_totals_nullbool: "请勾选您需要开票的订单商品",
  mes_code_successbool: "请输入正确的付款识别码！",
  mes_cancel_error: "取消失败！",
  mes_cancel_success: "取消成功！",
  mes_view_inner: "确定要取消该发票申请吗",
  mes_view_title: "提示",
  mes_no_code: "付款识别码不能为空",
  mes_disable: "该项金额正在申请发票或退款处理中",
  deduction_fee_header_shows_that: "扣费说明",
  deduction_fee_header_detail: "扣费明细",
  invoice_history_header_operation: "操作",
  invoice_history_header_status: "审核状态",
  invoice_history_header_remarks: "备注",
  invoice_history_header_reason: "意见",
  invoice_history_header_money: "申请开票金额",
  invoice_history_header_createDate: "申请时间",
  invoice_history_header_invoice_title: "发票抬头",
  invoice_history_header_applicatenum: "申请编号",
  invoice_list_header_subtotal: "小计",
  invoice_list_header_refund_amount: "退款金额",
  invoice_list_header_number: "数量",
  invoice_list_header_applied_amount: "申请金额",
  invoice_list_header_specification: "规格",
  invoice_list_header_goodsName: "商品名称",
  info_invoice_tracking_number: "快递单号",
  info_invoice_relation_phone: "联系电话",
  info_invoice_consignee_address: "收件地址",
  info_invoice_recipients: "收件人",
  info_invoice_status: "当前状态",
  info_invoice_companyPhone: "公司电话",
  info_invoice_registeredaddress: "公司注册地址",
  info_invoice_bankacount: "银行账号",
  info_invoice_accountname: "开户行名称",
  info_invoice_mergeMoney: "合并金额",
  info_invoice_applyMoney: "申请金额",
  info_invoice_applyUser: "申请人",
  info_invoice_applyNumber: "申请编号",
  info_invoice_type_text2: "增值税发票",
  info_invoice_type_text1: "普通发票",
  info_invoice_type: "发票类型",
  info_invoice_title: "发票抬头",
  info_taxcode: "纳税人识别号",
  info_file_title: "发票附件信息",
  info_order_title: "发票申请订单明细",
  info_post_title: "邮寄收件信息",
  info_invoice_header: "发票申请头信息",
  clone_btn: "关闭",
  info_title: "发票详细信息",
  list_cancel_btn: "取消申请",
  list_edit_btn: "修改资料",
  list_look_btn: "查看申请",
  invoiceInfoLineHeader_title: "商品名称",
  tabsThree: "扣费明细",
  tabsTwo: "申请记录",
  tabsOne: "发票申请",
  cost_item_hint: "该项金额正在申请发票或退款处理中",
  appy_time: "时间",
  booth_number: "展位号",
  payment_code: "支付码",
  especially_invoice_btn: "申请增值税专用发票",
  general_invoice_btn: "申请普通发票",
  tital_text: "开票总额：",
  load_more: "加载更多...",
  search: "搜索",
  reset: "重置",
  remitCode_input_placeholder: "请输入付款识别码",
  remitCode_placeholder: "多个识别码可依次输入点击“+”号添加再查找",
  remitCode: "付款识别码",
  exhibitionName: "展会",
  explainCode: "如果您是现场通过现金/刷卡缴费的，请通过付款识别码查询",
  explainCode_text:
    "现场缴纳的费用会在我们给您的小票中位于条形码下方，见图示例红色框内：",
  order_number: "订单号",
  发票需要到: "发票需要到",
  未到发票申请时间: "未到发票申请时间",
  之后才可以申请: "之后才可以申请",
  请输入想要查询的展位名: "请输入想要查询的展位名",
  展位号不存在: "展位号不存在",
  的展位: "的展位",
  提示: "提示",
  当前已选择开票金额: "当前已选择开票金额",
  元: "元",
  下一步: "下一步",
  以下订单为现场缴费订单:
    "以下订单为现场缴费订单，需要填写付款识别码才能申请发票",
  选择展位号: "选择展位号",
  查询展位号: "查询展位号",
  当前展位无订单: "当前展位无订单",
  您还没有选择展位: "您还没有选择展位，请先选择展位或直接输入展位号查询",
  请输入展位号: "请输入展位号",
  您还有未确认的现场订单: "您还有未确认的现场订单,是否重新确认?",
  提示: "提示",
  该展位号已存在: "该展位号已存在",
  发票状态: "发票状态",
  返回: "返回",
  "您的发票明细里面的订单正在进行退款，暂不能修改发票信息":
    "您的发票明细里面的订单正在进行退款，暂不能修改发票信息",

  WAITCHECK: "待审核",
  CHECKING: "审核中",
  CHECHED: "已审核",
  REFUSE: "未通过",
  CANCEL: "已导出",
  MERGE: "已合并",
  PASS: "已通过",
  CANCELED: "已取消",

  PUPIAO: "普票",
  ZHUANPIAO: "专票",

  下载发票: "下载发票"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/invoice.js